module.exports = __webpack_public_path__ + "img/logo.40292f93.png";